import { render } from "./Main.vue?vue&type=template&id=4d23efe6&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4d23efe6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d23efe6"

export default script